import { get } from '@/services/http';

export class MetricModel {
  public name: string;
  public code: string;
  public dataType: string = 'number';
  public formula: string = '';
  public columns: any = [];

  constructor(data: any = {}) {
    this.name = data.name;
    this.code = data.code;
    this.dataType = 'number';
    this.formula = data.formula;
    this.columns = [];

  }

  public mapData(data: any = {}) {
    this.name = data.name;
    this.code = data.code;
    this.dataType = data.dataType;
    this.formula = data.formula;
    this.columns = data.columns;
  }
}
